import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import sortBy from 'lodash/sortBy';
import { get } from 'lodash';
import { Video } from 'site-modules/shared/components/video';
import { OtherVideosList } from 'site-modules/shared/components/other-videos-list/other-videos-list';
import { Playlist } from 'site-modules/shared/components/playlist/playlist';

/**
 * Renders a whole video section with the following logic:
 *
 *  1.1) If there any videos that can be embedded directly to the page - Video frame appears
 *  1.2) If there more than 1 video that can be embedded - renders a playlist in addition to the Video frame
 *  2) If there videos that can be opened only outside the current page - displays them below the Video frame
 */
export class DealerVideos extends Component {
  static propTypes = {
    dealerInfo: PropTypes.shape({
      videos: PropTypes.arrayOf(
        PropTypes.shape({
          embedSrc: PropTypes.string,
          url: PropTypes.string,
          description: PropTypes.string,
          thumbnailUrl: PropTypes.string,
        })
      ),
    }),
  };
  static defaultProps = {
    dealerInfo: {},
  };

  static getDerivedStateFromProps(props, state) {
    const videos = get(props, 'dealerInfo.videos', []);
    const videosInRightOrder = sortBy(videos, ['order']);
    const embedVideos = videosInRightOrder.filter(meta => meta.embedSrc && meta.thumbnailUrl);
    const otherVideos = videosInRightOrder.filter(meta => !meta.embedSrc);
    return {
      embedVideos,
      otherVideos,
      selectedVideo: state.selectedVideo.embedSrc ? state.selectedVideo : embedVideos[0] || {},
    };
  }
  state = {
    embedVideos: [],
    selectedVideo: {},
    otherVideos: [],
  };

  selectVideo = selectedVideo => this.setState(() => ({ selectedVideo }));

  render() {
    const { embedVideos, otherVideos, selectedVideo } = this.state;
    if (!embedVideos.length && !otherVideos.length) {
      return null;
    }
    const playlist = embedVideos.filter(meta => meta.embedSrc !== selectedVideo.embedSrc);

    return (
      <Container id="edm-entry-dealer-videos" className="edm-entry mb-3 dealer-videos">
        <div className="size-30 fw-bold text-center pb-2">Videos</div>
        <Row className="justify-content-center">
          <Col lg={9} xl={8}>
            {selectedVideo.embedSrc && (
              <Video src={selectedVideo.embedSrc} type="IFrameEmbed">
                <Playlist videos={playlist} selectVideo={this.selectVideo} />
              </Video>
            )}
            <OtherVideosList
              videosList={otherVideos}
              videoLinkTrackingId="ddp_dealer_site_clickout"
              cardColumnSizeLg={'6'}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}
